import { Box } from 'src/components-v2/Layout';
import { CtaBanner } from 'src/sections';
import styled from 'threads5/themes/styled';

const Heading2 = styled('h2')(({ theme }) => {
  return {
    fontFamily: theme.typography.plaidSans,
    fontSize: '6.0rem',
    fontWeight: 600,
    letterSpacing: '-2px',
    lineHeight: '100%',
    background:
      'var(--gradient-background-subtle-benjamin, linear-gradient(48deg, #02294B 0%, #012E37 50%, #013703 100%))',
    backgroundClip: 'text',
  };
});

const ButtonLink = styled('a')(({ theme }) => {
  return {
    display: 'flex',
    padding: '0 22px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '1000px',
    border: '1px solid #FFF',
    background: 'linear-gradient(78deg, #111112 0%, #373839 100%)',
    color: theme.palette['base/white/white'],
    ':hover, :focus': {
      color: theme.palette['base/white/white'],
      boxShadow: theme.palette['web3/component/button/primary/box-shadow'],
      mixBlendMode: 'luminosity',
    },
    gap: '8px',
    flex: '1 0 0',
    alignSelf: 'stretch',

    textAlign: 'center',
    fontFamily: theme.typography.sans,
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%' /* 30px */,
  };
});

const SandboxBanner = () => {
  return (
    <CtaBanner
      sx={{
        padding: 0,
        position: 'relative',
        background: 'transparent',
      }}
      innerSx={{
        background:
          'linear-gradient(268deg, #E6E6FF 1.58%, #D8FEF3 48.79%, #9AEDFE 95.06%)',
        boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.08)',
        textAlign: {
          xs: 'center',
          sm: 'left',
        },
      }}
    >
      <Heading2>Start testing in sandbox for free</Heading2>
      <Box
        sx={{
          display: 'flex',
          height: '48px',
          padding: '2px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ButtonLink href='https://dashboard.plaid.com/signup'>
          Try it now
        </ButtonLink>
      </Box>
    </CtaBanner>
  );
};

export default SandboxBanner;
